class URLHelper {
  constructor() {
    /**
     * @type { { baseUrl: string, fullUrl: string, urlWithoutHash: string, params: *[], pathname: string, queryString: null, hash: string, slug: string, hashContent: string } }
     */
    this.parsedUrlObject = this.parseUrl();
    this.eventListener = {
      popState: [],
    };
  }

  initEventHandler() {
    if(this.eventListener.popState.length > 0) {
      window.onpopstate = event => {
        for(const callbackFunction of this.eventListener.popState) {
          callbackFunction(event);
        }
      };
    }
  }

  addEventListener(event, callbackFunction) {
    if(!this.eventListener[event]) {
      return;
    }
    this.eventListener[event].push(callbackFunction);
    this.initEventHandler();
  }

  createBaseObject() {
    return {
      baseUrl: window.location.href.split(`#`)[0],
      fullUrl: window.location.href,
      hash: window.location.hash,
      hashContent: window.location.hash.replace(`#`, ``),
      params: [],
      pathname: window.location.pathname,
      queryString: null,
      slug: window.location.pathname.replace(/(^\/|\/$)/g, ``),
      urlWithoutHash: window.location.href.replace(window.location.hash, ``),
    };
  }

  /* eslint-disable prefer-destructuring */
  parseUrl() {
    const urlObject = this.createBaseObject();
    if(urlObject.fullUrl.indexOf(`?`) !== -1) {
      const urlSplit = urlObject.urlWithoutHash.split(`?`);
      urlObject.baseUrl = urlSplit[0];
      urlObject.queryString = urlSplit[1];
    }
    if(urlObject.queryString) {
      let pairs = urlObject.queryString.split(`&`);
      if(pairs[0] === ``) {
        pairs = pairs.splice(0, 1);
      }
      urlObject.params = pairs.map(pair => {
        const pairSplit = pair.split(`=`);
        return {
          key: pairSplit[0],
          value: pairSplit[1],
        };
      });
    }
    return urlObject;
  }
  /* eslint-enable prefer-destructuring */

  setHash(hash) {
    this.parsedUrlObject.hash = `#${hash}`;
    this.parsedUrlObject.hashContent = hash;
    this.parsedUrlObject.fullUrl = `${this.parsedUrlObject.urlWithoutHash}${this.parsedUrlObject.hash}`;
  }

  setParam(key, value) {
    const id = this.parsedUrlObject.params.findIndex(pair => pair.key === key);
    if(id === -1) {
      this.parsedUrlObject.params.push({ key, value });
    } else {
      this.parsedUrlObject.params[id] = { key, value };
    }
    const pairs = this.parsedUrlObject.params.map(obj => `${obj.key}=${obj.value}`);
    this.parsedUrlObject.urlWithoutHash = `${this.parsedUrlObject.baseUrl}?${pairs.join(`&`)}`;
    this.parsedUrlObject.fullUrl = `${this.parsedUrlObject.urlWithoutHash}${this.parsedUrlObject.hash}`;
  }

  removeParam(key) {
    this.parsedUrlObject.params = this.parsedUrlObject.params.filter(item => item.key !== key);
    const pairs = this.parsedUrlObject.params.map(obj => `${obj.key}=${obj.value}`);
    this.parsedUrlObject.urlWithoutHash = (pairs.length > 0) ? `${this.parsedUrlObject.baseUrl}?${pairs.join(`&`)}` : this.parsedUrlObject.baseUrl;
    this.parsedUrlObject.fullUrl = `${this.parsedUrlObject.urlWithoutHash}${this.parsedUrlObject.hash}`;
  }
}

export default new URLHelper();
